import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getLabelGroupQueryDocument } from "./label-group.gql";

export interface UseGetLabelGroupProps {
  id?: string;
  enabled?: boolean;
}

export const useGetLabelGroup = ({ id, enabled = true }: UseGetLabelGroupProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.labelGroups.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Label Group ID is required");
      }

      const client = createOperationClient("GetLabelGroup");
      const data = await client.request(getLabelGroupQueryDocument, { input: { id } });

      return data.labelGroup;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const labelGroup = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    loading: queryResult.isLoading,
    error: queryResult.error,
    labelGroup,
    queryResult,
  };
};
